export default {
  banner: {
    title: "先进制造解决方案",
    subtitle:
      "深耕芯片、机器人、航空航天、医药医械等先进制造行业，为企业搭建高生产力、高安全、高性能的身份管理平台，构筑数字化地基，助力企业在高速成长中免除后顾之忧。",
  },
  marquee: {
    item1: {
      title1: "仙工智能",
      desc1:
        "以智能控制器和数字化软件为核心产品组合，致力于实现工业物流的智能化。",
      title2: "快速构建身份管理",
      desc2:
        "我们高度重视供应商应用的灵活性与可靠性，Authing 的「嵌入、集成、连接」理念与我们的需求不谋而合。合作后，我们快速地通过 Authing 完成了对内的员工身份管理和对外的客户身份管理，大大节省了我们的时间精力。",
    },
    item2: {
      title1: "Alpha Cen",
      desc1: "Alpha Cen 是一家源自美国硅谷的光操控芯片公司。",
      title2: "灵活搭建身份基础设施",
      desc2:
        "在苹果公司和德州仪器的经验，让我们深知统一身份管理要从 day 1 做起，Authing 提供了我们所使用的各类工程软件及平台的接口，我们只用了很少的精力就搭建起了完整的身份基础设施。",
    },
    item3: {
      title1: "非夕科技",
      desc1: "非夕科技致力于打造第三代自适应智能机器人，在全球技术领先。",
      title2: "大幅减少开发成本",
      desc2:
        "随着公司发展与业务需要，公司陆续要采购各类应用，不同的第三方厂商在身份模块的标准与技术均不相同。所幸，我们在早期就与 Authing 建立了合作，基于 Authing 统一的身份管理标准，为员工提供了一致性的身份认证模式，大大提升了企业应用的访问体验，并为未来建立身份中台做好了前期技术准备。",
    },
    item4: {
      title1: "某超大型 IDM 芯片厂商",
      desc1: "致力于动态随机存取存储芯片 DRAM 的设计、研发、生产和销售。",
      title2: "高效实现复杂需求",
      desc2:
        "Authing 对开发者非常友好，有大量即需即用的 API 与 SDK，开发者文档细致规范，即使是我们内部非常复杂的需求，也可以像搭积木一样快速地构建可供复用的产品，与我们的技术理念不谋而合。",
    },
    item5: {
      title1: "全球生命科学技术服务提供商",
      desc1: "致力于开发创新型疫苗、生物药物以及新型细胞和基因疗法。",
      title2: "精细化认证鉴权",
      desc2:
        "Authing 的产品极大契合了我们在设备及硬件管理（IoT）中的认证鉴权需求，非常感谢 Authing 持续的支持，你们的专业性和高度投入让我和我的团队印象深刻，期待与 Authing 的长期合作。",
    },
  },
  plight: {
    title: "先进制造企业为何纷纷构建专业的身份管理体系？",
    desc: "夯实数字化身份基础，免除企业扩张后顾之忧",
    itemOne: {
      title: "经历过才知道的痛",
      desc:
        "“我曾任职于一家数千人规模的大型企业，由于没有提前规划身份体系，出现了上千僵尸账号，不少员工离职后仍然可以访问机密文件。为了亡羊补牢，公司不仅投入大量人力财力，还耗费数个季度的时间。所以当我到了现在的公司，第一件事就是与 Authing 合作搭建完善的身份基础设施。”",
      role: "——  某 AI 机器人公司 IT 总监",
    },
    itemTwo: {
      title: "行业内的前车之鉴",
      desc:
        "“看到 AMD 因为内部弱口令被黑客盗取 450 GB 数据进行公开勒索的新闻，我们立刻做了内部扫描，发现了不少类似的漏洞。最后选择与 Authing 合作，也是因为他们在密码管理上有非常丰富的产品能力，而且还有全链路的审计能力，很好地帮我们补足了内部管理的短板。”",
      role: "——  某 5G 芯片设计公司信息化负责人",
    },
  },
  chart: {
    title: "越早构建专业的身份管理体系，所需投入的总成本越低",
    content1: {
      title: "百人阶段",
      subtitle: "初创阶段 打磨产品",
      tooltip: {
        title: "初期介入",
        content: "百人规模时主动构建底层身份体系，花费少、长期性价比极高。",
      },
    },
    content2: {
      title: "千人阶段",
      subtitle: "成长阶段 人员扩张",
      tooltip: {
        title: "中期介入",
        content: "人员和应用同步增长，身份管理成倍复杂化，问题解决正当时。",
      },
    },
    content3: {
      title: "万人阶段",
      subtitle: "进阶阶段 领跑行业",
      tooltip: {
        title: "后期介入",
        content:
          "至万人规模时被迫构梳理身份体系，部署和定制化费用高、投入人力成本巨大。",
      },
    },
    content4: {
      title: "数万人阶段",
      subtitle: "成熟阶段 精细运营",
      tooltip: {
        title: "",
        content: "",
      },
    },
    legend1: {
      text: "初期即构建身份体系的成本",
    },
    legend2: {
      text: "中后期才梳理身份体系的成本",
    },
    chartTitle: "投入成本",
    legendDesc:
      "此处成本为预估，实际费用请参考官网定价或与您的客户经理联系进行评估",
  },
  question: {
    title: "企业高速发展，身份管理痛点突显",
    mainTop: {
      title: "身份安全建设滞后",
      desc:
        "企业发展过程中，容易忽视身份安全建设在其中的重要地位，导致核心知识资产的泄漏： ",
      descli1:
        "密码认证无保护：弱密码、密码疲劳问题多发，核心资产暴露于黑客访问攻击之下；",
      descli2:
        "风控验证少措施：“事前验证”能力弱，导致“事后补救”耗费更多人力物力；",
      descli3:
        "资源授权不规范：过度授权、权限回收不及时问题频发，无法做到统一权限管理；",
      descli4: "登录信息难追溯：访问记录、操作日志缺失，存在多处管理死角。",
      desclast: "",
      mobileDesc:
        "高精尖知识资产受保护程度低，面对猖獗的访问攻击，核心商业机密有泄漏风险。员工登录时需有更为安全的认证方式及风控策略，登录后需有更灵活的审计能力便于追踪。",
    },
    mainBottom: {
      item1: {
        title1: "AD 域短板日渐显著",
        title2: "",
        contentli1: "价格高、操作复杂，对企业预算及人力要求较高；",
        contentli2: "协议支持单一，兼容性弱，无法兼容新兴应用；",
        contentli3:
          "单一 AD 多域耦合，多域间设备、应用、人员存在互相影响的风险",
        mobileDesc:
          "Windows AD 认证臃肿、扩展性弱、难以支持大量新兴 B/S 架构应用，更难以覆盖出差及远程办公场景。",
      },
      item2: {
        title: "入转调离管理不便",
        content: "企业人事变动频繁，应用间组织架构无法自动同步：",
        contentli1:
          "管理不便：员工在入转调离各阶段，管理员需分别改动该员工对应的应用权限及架构，工作低效重复；",
        contentli2: "安全风险：管理员手动改动权限，因为漏关权限造成安全隐患。",
        mobileDesc:
          "发展期间人事变动频繁，应用间组织架构无法同步，员工在入转调离各个阶段、管理员需分别改动各应用权限及架构，工作低效重复，更有漏关权限带来的安全隐患。",
      },
    },
    aside: {
      title: "应用系统割裂严重",
      desc: "企业业务持续扩张，不断采购新应用，大量新老应用并存：",
      descli1:
        "应用认证：系统多且复杂，多个应用使用多种认证方式，使用难、管理难；",
      descli2: "身份信息：存在多套组织架构，身份变更时需重复修改，难以打通；",
      descli3: "资源授权：无法基于一个平台管理所有权限，多处操作，繁琐不便；",
      descli4:
        "审计管理：各应用的审计信息分散在不同的业务系统中，难以整合成统一看板。",
      desclast: "",
      mobileDesc:
        "业务扩张时，企业快速研发或采购多套新业务系统。但因底层身份割裂，员工登录时重复认证、忘记密码，信息化人员难以统一管理，问题愈演愈烈。",
    },
  },
  advantage: {
    item1: {
      title: "构建零信任风控中台，保障企业安全",
      desc:
        "Authing 帮助企业统一安全管理，在事前设置零信任的访问控制策略、密码策略、授权管理；事中动态提权、降权，进行实时且多维度的评估和告警；事后进行全面的身份审计、溯源、分析，持续优化风控引擎。 ",
      alt: "",
    },
    item2: {
      title: "搭建身份底座，提升员工效率、管理更便捷",
      desc:
        "Authing 预集成了大量先进制造常用系统，包含 OA、ERP、PLM 等。通过打通应用间身份体系，员工访问入口统一，仅需一次认证，即可免密登录所有有权限的应用，不再有记忆密码的困扰；管理员可以轻松统一管理所有应用的访问权限。",
      alt: "",
    },
    item3: {
      title: "入转调离自动化，减少运维负担、避免人为操作风险",
      desc:
        "管理员可将 OA 或 HR 系统的身份体系作为身份源，在员工「入转调离」的过程中，仅需维护一套身份信息，即可通过 Authing 同步至其他应用。实现一处管理、处处同步，避免人为操作带来的漏关、错关风险。",
      alt: "",
    },
    item4: {
      title: "补全 AD 域短板、管理更灵活",
      desc:
        "自动化实现 Windows AD 身份目录同步及 OU 组信息同步，帮助企业解耦 AD 系统认证的负担，Authing 支持 OIDC、SAML、Oauth、CAS、LDAP 等标准协议，可覆盖 AD 对 B/S 系统的完整解决方案，为企业提升扩展性、便捷性。",
      alt: "",
    },
  },
  productivity: {
    title: "选择高安全、高性能、高生产力的身份产品",
    item1: {
      title: "高安全",
      desc1:
        "数据存储使用 AES-256 算法加密；通过 SSL/TLS 协议加密传输；使用 KMS 管理密钥，密钥定期轮换。",
      desc2: "7x24 小时的安全应急响应；两地三中心备份，保证灾难时快速恢复。",
      desc3: "ISO、等保三级、数据保护条例等多项认证。",
    },
    item2: {
      title: "高性能",
      desc1:
        " 云原生：采用 Kubernetes 容器化技术，支持分钟级别弹性扩容，最大可支持亿级别用户认证访问场景。",
      desc2: "云中立：最大程度兼容用户的云环境，不被原有的云厂商捆绑。",
    },
    item3: {
      title: "高生产力",
      desc1: " 开发者友好：提供丰富登录、认证、授权 API/SDK，降低研发成本。",
      desc2: "快速集成 2000+ 主流应用，简单、高效的建立身份中台。",
    },
  },
  other: {
    title: "深入了解你的行业，都如何构建身份体系",
    item1: {
      title: "芯片行业解决方案",
      desc: "为芯片行业统一认证及鉴权，除去安全隐患、保障核心知识资产。",
    },
    item2: {
      title: "机器人行业解决方案",
      desc: "打通网络、设备、身份链路的安全防护，助力机器人行业技术升级。",
    },
    item3: {
      title: "航空航天解决方案",
      desc: "快速搭建身份中台、统一安全管理，推动航空航天行业智能发展。",
    },
    item4: {
      title: "医药医械业解决方案",
      desc: "为医药医械业快速实现合规经营，提高“互联网+医疗”的安全与效率。",
    },
    downText: "下载方案",
  },
  download: {
    title: "提交表单",
    subtitle: "立即下载解决方案",
    desc: "请选择你的文件下载",
    button: "立即下载",
    solution: "下载方案",
  },
};
